import Axios, { AxiosInstance } from 'axios';
const isLocalhost =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';
// Only include token if running on localhost

// const token = null;
const token = isLocalhost
  ? '327975|MzRQpaJkfK5BPnBZAohWhZr3OVAVTSVoYaAfmvQo'
  : null;

const axios: AxiosInstance = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
  headers: {
    ...(isLocalhost && { Authorization: `Bearer ${token}` }),
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
});
export default axios;
